export const DEFAULT_BOUNDS = {
    sw: {
        lat: 50.908703,
        lng: 3.361014,
    },
    ne: {
        lat: 53.514875,
        lng: 7.233842,
    },
};

export const MAP_STYLES: google.maps.MapTypeStyle[] = [
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];

export const icons = {
    cluster: 'https://grandvision.s3.amazonaws.com/pblx/images/gnl-cluster.svg',
    marker: 'https://grandvision.s3.amazonaws.com/pblx/images/pearle-marker.svg',
    markerHover:
        'https://grandvision.s3.amazonaws.com/pblx/images/pearle-marker-white.svg',
    currentPosition:
        'https://grandvision.s3.amazonaws.com/pblx/images/user-location.svg',
};
